import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { createFilterOptions } from '@mui/material/Autocomplete';
import { useField, useFormikContext } from "formik";
import { at } from 'lodash';
import React, { useEffect, useState,useRef } from "react";
import { useTranslation } from "react-i18next";
import useStaticData from "./UseStaticData";
import { makeStyles } from "@material-ui/core/styles";
import useMUIStyleHelper from "../UseMUIStyleHelper";

function CsplAchField(props) {
  
  const [lookupData, setLookupData] = useState([]);
  const [isLookupProcessing, getLookupData] = useStaticData();
  const { t, i18n } = useTranslation("common");

  const {lookupName,filterValue,idColumn,displayColumn,getIdValue, errorText,secondaryColumn, ...rest } = props;
  const pr  = useField(props);
  const [field, meta, form] = useField(props);
  const { name } = field
  const {setTouched, setValue  } = form;
  const { setFieldValue } = useFormikContext();
  const [controlValue, setControlValue] =useState(null);
  const prevFilterValueRef = useRef();   

 const { mandatoryClasses, nonMandatoryClasses } = useMUIStyleHelper();

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
  }

     /* When ever lookup name changed get the data for the new lookup */
     useEffect(() => {
      getLookup();
    }, [lookupName]);


  //  /* When ever filter value changed get the data for the new lookup */
  // useEffect(() => {
  //   if(filterValue != '' &&  filterValue !=  prevFilterValueRef.current && filterValue != undefined){
  //     getLookup();
  //   }
  //   prevFilterValueRef.current = filterValue;
  // }, [filterValue]);

  useEffect(() => {   
      getLookup();
  }, [filterValue]);


  const getLookup= ()=>{
    const [touched] = at(meta, 'touched');
    
  getLookupData(lookupName, filterValue).then(
    (res) => {
      setLookupData(res);
      if(touched){
       // setFieldValue(name , null);
      }       
    },
    (error) => {
      if(touched){
       // setFieldValue(name,null);
      }        
    }
  );
  }

  useEffect(() => {
   // getLookup();
   setControlValue(field.value);
   emitIdValue(field.value)
  }, [field.value]);

  function emitIdValue(newValue) {
    if (idColumn &&
      getIdValue && typeof getIdValue === "function") {
        if(newValue && newValue[idColumn])
           getIdValue(newValue[idColumn]);
        else
          getIdValue(null);
    }
  }

  /**
   * handle ach value change and if props onValueChange configured the 
   * call it by new value
   * @param {event} event 
   * @param {object} value 
   */
  const handleOnValueChange=(event ,value)=>{ 
    event.preventDefault();
    setFieldValue(name , value); 
     emitIdValue(value); 
     if(props.onValueChange && typeof(props.onValueChange)==="function"){
       props.onValueChange(value);
     }
  }
  
  //filter options which provide filter search results
  //if secoundary column is present filter includes secondary column content 
  //else include primary column alone
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 500,
    stringify: (option) =>
      secondaryColumn
        ? option[displayColumn] + option[secondaryColumn]
        : option[displayColumn],
  });

  return (<>
    {props.required ?
      <Autocomplete
    {...field}
    {...rest}
   
    value={controlValue}
      onChange={(event, value) => handleOnValueChange(event,value)}
      onBlur={() =>{ setTouched({ [name]: true })}}
      options={lookupData}
      getOptionLabel={(option) =>option[displayColumn]}
      getOptionSelected={(option, value) =>
         value && option[idColumn] === value[idColumn]
      }
      isOptionEqualToValue={(option, value) =>
        value && option[idColumn] === value[idColumn]
      }
      filterOptions={filterOptions}
      size="small" 
      renderOption={(props, option, state) => {
        return (
          <><li {...props}>{secondaryColumn ? (option[displayColumn] + " - " + option[secondaryColumn] ) : option[displayColumn]}</li>
           {/*  {secondaryColumn ? (
              <Box component="li" {...props}>
                <Typography variant="body1" width={"35%"}>
                  {option[displayColumn]}
                </Typography>
                <Typography variant="body2" color="textSecondary" width={"65%"}>
                  {option[secondaryColumn]}
                </Typography>
              </Box>
            ) : (
              
            )} */}
          </>
        ); //display value
      }} 
      renderInput={(params) => (
        <TextField
          {...params}
          error={meta.touched && meta.error && true}
          helperText={_renderHelperText()}
          variant="outlined"
          label={t(props.label)}
           InputLabelProps={{ shrink: true }} 
          required={props.required}
          className={mandatoryClasses.root}
        />
      )}
    />
    :
    <Autocomplete
    {...field}
    {...rest}
  
    value={controlValue}
      onChange={(event, value) => handleOnValueChange(event,value)}
      onBlur={() =>{ setTouched({ [name]: true })}}
      options={lookupData}
      getOptionLabel={(option) => option[displayColumn]}
      getOptionSelected={(option, value) =>
        value && option[idColumn] === value[idColumn]
      }
      isOptionEqualToValue={(option, value) =>
        value && option[idColumn] === value[idColumn]
      }     
      size="small" 
      renderOption={(props, option, state) => {
        return (
          <><li {...props}>{secondaryColumn ? (option[displayColumn] + " - " + option[secondaryColumn] ) : option[displayColumn]}</li>
          </>
        ); //display value
      }}    
      renderInput={(params) => (
        <TextField
          {...params}
          error={meta.touched && meta.error && true}
          helperText={_renderHelperText()}
          variant="outlined"
          label={t(props.label)}
          shrink
          notched
          required={props.required}
          InputLabelProps={{ shrink: true }} 
          className={nonMandatoryClasses.root}
             
        />
      )}
    />
    }
  </>
   
  );
}
export default CsplAchField;
